var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestionMark = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 21,
  fill: "none",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.6,
  clipPath: "url(#question-mark_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 19.209a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667ZM10 15.042h.008"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.575 8.375a2.5 2.5 0 0 1 4.859.834c0 1.667-2.5 2.5-2.5 2.5"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "question-mark_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .875h20v20H0z"
})))));
SvgQuestionMark.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionMark);
export default ForwardRef;